import { apiRequest } from './client';

export interface Bbox {
  min_lat: number;
  min_lng: number;
  max_lat: number;
  max_lng: number;
}

export async function fetchVisitedCellsInBbox(bbox: Bbox): Promise<string[]> {
  const qs = new URLSearchParams({
    min_lat: bbox.min_lat.toString(),
    min_lng: bbox.min_lng.toString(),
    max_lat: bbox.max_lat.toString(),
    max_lng: bbox.max_lng.toString(),
  });
  const data = await apiRequest<{ cells: string[] }>(`/cells/visited-bbox?${qs.toString()}`);
  return data.cells;
}
